import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { CacheService } from './cache.service';

export const provideCache = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideEnvironmentInitializer(() => inject(CacheService)),
    ];
};
